<section class="left" [ngClass]="{'hide-screen-sm': searchResults}">
  <button class="ficon-arrow-left back-btn" role="button" aria-label="back" (click)="back()"></button>
  <img class="left-image" src="https://staticassets.goreact.com/shapes.svg">
</section>

<section class="right">
  @if (defaultInvites.length === 0 && !!allOrgs) {
    <div class="org-search-panel">
      @if (!searchResults) {
        <h1 class="title" translate>sign-up-org-search_search-title</h1>
      }
      <div class="search-bar">
        <div class="input-group" role="search">
          <span class="search-txt" translate>common_search</span>
          <input
            id="org-search-field"
            class="form-control search-input"
            type="search"
            autofocus
            [(ngModel)]="searchTerm"
            (keyup)="search()"
            data-cy="org-search-field">
          @if (!searchTerm) {
            <span class="input-group-addon"><i class="ficon-search"></i></span>
          }
          @if (searchTerm) {
            <span class="input-group-addon search-clear">
              <button (click)="clearSearch()" aria-label="clear search" class="ficon-app-x btn-none"></button>
            </span>
          }
        </div>
      </div>
      @if (!searchResults) {
        <div class="create-org-panel">
          <div id="hr"><span id="or" translate>sign-up-org-search_or-separator</span></div>
          <h1 class="hide-screen-sm title" translate>sign-up-org-search_create-title</h1>
          <p translate>sign-up-org-search_create-description</p>
          <button
            class="submit-btn secondary-btn"
            (click)="createOrg()"
            translate
          data-cy="org-search-create-btn">common_create</button>
        </div>
      }
      @if (searchResults && searchResults.length !== 0) {
        <div class="search-results-panel">
          <span class="search-result-count">{{searchCountTranslation}}</span>
          <div class="search-results">
            <div class="result-wrapper">
              @for (result of searchResults; track result) {
                <div class="search-result" [ngClass]="{ 'unjoinable': !result.open_access }">
                  <span>{{result.name}}</span>
                  @if (result.open_access) {
                    <button
                      class="submit-btn primary-btn join-btn"
                      (click)="selectOrg(result)"
                      data-cy="org-search-join-btn"
                      translate="sign-up-org-search_join-btn">
                    </button>
                  }
                  @if (!result.open_access) {
                    <button
                      type="button"
                      suffix
                      class="icon ficon-app-help-circle-outline icon-btn"
                      [goCdkPopover]="'sign-up-no-join-org' | translate"
                    ></button>
                  }
                </div>
              }
            </div>
          </div>
          <div class="org-search-footer">
            <span translate>sign-up-org-search_create-footer-description</span>
            <button type="button" class="link-btn goreact-btn" (click)="createOrg()" translate>sign-up-org-search_create-org-link</button>
          </div>
        </div>
      }
      @if (searchResults && searchResults.length === 0) {
        <div class="no-results">
          <h1 translate [translateParams]="{searchTerm}">sign-up-org-search_no-results-title</h1>
          <p translate>sign-up-org-search_no-results-description</p>
          <div class="org-search-footer">
            <span translate>sign-up-org-search_create-footer-description</span>
            <button type="button" class="link-btn goreact-btn" (click)="createOrg()" translate>sign-up-org-search_create-org-link</button>
          </div>
        </div>
      }
    </div>
  }

  @if (defaultInvites.length > 0 && !!allOrgs) {
    <div class="default-join-panel">
      <h1 translate>sign-up-org-search_join-title</h1>
      <span class="invites-text" translate>sign-up-org-search_join-description</span>
      <div class="search-results join-results">
        <div class="result-wrapper">
          @for (invite of defaultInvites; track invite) {
            <div class="search-result">
              <span>{{invite.name}}</span>
              <button
                class="submit-btn primary-btn join-btn"
                (click)="selectOrg(invite)"
                data-cy="org-search-join-btn"
                translate="sign-up-org-search_join-btn">
              </button>
            </div>
          }
        </div>
      </div>
      <div class="org-search-footer">
        <span translate>sign-up-org-search_search-footer-description</span>
        <button type="button" class="link-btn goreact-btn" data-cy="org-search-for-more" (click)="startSearch()" translate>sign-up-org-search_search-link</button>
      </div>
    </div>
  }

  @if (!allOrgs) {
    <div class="not-loaded">
      <h1 class="title" translate>sign-up-org-search_search-title</h1>
      <p translate>sign-up-org-search_not-loaded-text</p>
      <button translate class="submit-btn primary-btn reload-btn" (click)="reloadOrgs.emit()">sign-up-org-search_reload-btn</button>
    </div>
  }

  <div class="steps-wrapper content goStepperClass">
    <span class="step is-active"></span>
    <span class="step is-active"></span>
    <span class="step"></span>
  </div>
</section>
